import mutations from "./mutations.js";
import actions from "./actions.js";
import getters from "./getters";

export default {
  namespaced: true,
  state: () => ({
    notifications: [],
    newMessageNotificationsCount: 0,
    sessionUpdateNotificationsCount: 0,
  }),
  mutations,
  actions,
  getters,
};
